import { trim } from 'lodash-es';

import { EXTERNAL, INTERNAL } from '~/components/NavLink/NavLink';
import { HOME_URI } from '~/constants/page-uri';

export default {
    methods: {
        mapType(type) {
            switch (type) {
            case 'internalLink2_Entry':
            case 'internalLink_Entry':
            case 'internalLink3_Entry':
                return INTERNAL;
            case 'externalLink2_Entry':
            case 'externalLink_Entry':
            case 'externalLink3_Entry':
                return EXTERNAL;
            }
        },
        mapURI(link) {
            switch (this.mapType(link.__typename)) {
            case INTERNAL:
            {
                const uri = link?.page?.[0]?.uri ?? '';
                const url = this.fixHomeUri(uri);
                const tUrl = trim(url, '/');

                return tUrl ? `/${tUrl}/` : '/';
            }
            case EXTERNAL:
                if (typeof link === 'string') {
                    if (link[0] === '/') {
                        // If route parameter is a path, create route object with path.
                        return this.$localePath(link);
                    }
                }

                return link.linkUrl;
            }
        },
        getLink(entry) {
            const uri = entry?.uri ?? '';
            const url = this.fixHomeUri(uri);
            const tUrl = trim(url, '/');

            return tUrl ? `/${tUrl}/` : '/';
        },
        fixHomeUri(uri) {
            if (uri === HOME_URI) {
                return '';
            }

            return uri;
        }
    }
};
